import React, { useEffect, useState } from 'react';
import './MetricsScoreCard.scss';
import gears from '../../assets/Gears.png';
import { MetricCircularChart } from '../metricCircularChart/MetricCircularChart';
import { useGetScorecardBonusPenaltyDataQuery } from '../../pages/managerDashboard/managerDashboardSlice';

interface ScorecardMetricsProps {
    scorecardVersion: number;
    inputmonth: number;
    inputyear: number;
}

export const ScorecardMetrics: React.FC<ScorecardMetricsProps> = ({
    scorecardVersion,
    inputmonth,
    inputyear,
}) => {
    const [monthlyMetrics, setMonthlyMetrics] = useState<any>([]);

    const { data: monthlyMetricsData } = useGetScorecardBonusPenaltyDataQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion ?? 0,
        },
        {
            skip: !scorecardVersion || !inputyear || !inputmonth,
        }
    );
    /* eslint-disable camelcase */
    useEffect(() => {
        if (monthlyMetricsData?.data?.length > 0) {
            const transformedData = monthlyMetricsData.data.map((row: any) => ({
                metric: {
                    label: row.label,
                    target: row.client_target || row.target,
                    metric_value: row.metric_value,
                    metric_type_name: row.metric_type_name,
                    metric_direction_id: row.metric_direction_id,
                    metric_id: row.metric_id,
                    metric_attained: calculateMetricAttained(
                        row.metric_value,
                        row.client_target || row.target,
                        row.metric_direction_id
                    ),
                    metric_omitted: row.metric_omitted || false
                },
            }));

            setMonthlyMetrics(transformedData);
        } else {
            setMonthlyMetrics([]);
        }
    }, [monthlyMetricsData]);

    // Helper function (place outside the component or in a utils file)
    const calculateMetricAttained = (
        value: number,
        target: number,
        direction: number
    ): boolean => {
        if (!value || !target) return false;

        if (direction === 1) {  // Higher is better
            return value >= target;
        } else if (direction === 2) {  // Lower is better
            return value <= target;
        }
        return false;
    };

    return (
        <div className="metrics-score-card">
            <div style={{ fontSize: '1.25rem', padding: '0.5rem 0.5rem', color: '#3F5765' }}>Scorecard Metrics</div>
            <div className="metrics-scroll-wrapper mt-3">
                <div className="metrics-card-row">
                    {monthlyMetrics?.length > 0 ? (
                        monthlyMetrics?.map((metric: any, i: number) => {
                                return (
                                    <MetricCircularChart key={metric.metric.metric_id ?? i} metric={metric.metric} index={i} />
                                );
                            })
                    ) : (
                        <div className="no-data-wrapper">
                            <div className="no-data-inner">
                                <img src={gears} alt="No Data" className="gears-img" />
                                <div className="no-data-text">
                                    No Data
                                    <br />
                                    Available
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
